import React from "react";

export const NDA_NUMBER = "11757727775";
export const NDA_SENTENCE =
  "Déclaration d'activité enregistrée sous le numéro 11757727775 auprès du préfet de la région Île-de-France. Cet enregistrement ne vaut pas agrément de l'État.";

export const NdaMention = ({ variant = "light", className = "" }) => {
  const dark = variant === "dark";
  return (
    <p
      className={`text-xs leading-relaxed ${dark ? "text-gray-400" : "text-gray-500"} ${className}`}
      data-testid="nda-mention"
    >
      <span className={`font-semibold ${dark ? "text-white" : "text-[#003087]"}`}>NDA {NDA_NUMBER}</span> — {NDA_SENTENCE}
    </p>
  );
};

export const NdaLegalBox = () => (
  <div
    className="rounded-xl p-5 md:p-6 border-l-4 border-[#F07B1D]"
    style={{ backgroundColor: "#F5F7FA" }}
    data-testid="nda-legal-box"
  >
    <p className="text-sm font-bold text-[#003087] mb-1">Organisme de formation déclaré · NDA {NDA_NUMBER}</p>
    <p className="text-sm text-gray-700 leading-relaxed">{NDA_SENTENCE}</p>
    <p className="text-xs text-gray-500 mt-2">
      MGB School · SASU · SIRET 999 673 635 00010 · 25 rue de Ponthieu, 75008 Paris · Exonération de TVA art. 261-4-4° du CGI.
    </p>
  </div>
);
